// src/utils/slugHelper.js
/**
 * Generate a URL-friendly slug from a game title
 * @param {string} title - The game title to convert to a slug
 * @returns {string} A URL-friendly slug
 */
export const createSlug = (title) => {
  if (!title) return '';
  
  return title
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-')         // Replace spaces with hyphens
    .replace(/-+/g, '-')          // Avoid multiple consecutive hyphens
    .trim();
};

/**
 * Get the slug from a game object, generating one if needed
 * @param {Object} game - The game object
 * @returns {string} The game's slug
 */
export const getGameSlug = (game) => {
  if (!game) return '';
  
  // Use existing slug if available
  if (game.slug) return game.slug;
  
  // Otherwise, generate from title
  return createSlug(game.title);
};
